import React, { useRef, useState, useEffect } from 'react';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import useEffectOnce from '../hooks/useEffectOnce';
import { useDispatch } from 'react-redux';
import { fetchdata, fetchviewdata, fetchviewDoc } from '../reduxactions/adminrsactions/AdViewOrgActions';
import { Card } from 'primereact/card';
import { Panel } from 'primereact/panel';
import { useSelector } from 'react-redux';
import { RootState } from '../reducers';
import { GFNButton } from '../ui/GFNButton';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';

import { useLocation, useNavigate, useParams } from 'react-router-dom';
export const AdminViewOrg = () => {

  const uid = window.sessionStorage.getItem('uid');
  const [globalFilter, setGlobalFilter] = useState('');

  const location = useLocation();

  const [queryParams, setQueryParams] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    setQueryParams(params.get("orgID") as any);
  }, [location]);
  const { orgID } = useParams();
  console.log('Row ID:', orgID);
  const dispatch = useDispatch()
  const data = useSelector((state: RootState) => state.adorgdocument.data);
  const viewdata = useSelector((state: RootState) => state.adorgdocument.viewdata);
  const docdata = useSelector((state: RootState) => state.adorgdocument.docdata);

  //To get data
  const fetchDataAsync = async () => {
    try {
      await dispatch(fetchdata(orgID) as any);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const fetchDataViewAsync = async () => {
    try {
      await dispatch(fetchviewdata(orgID) as any);
    } catch (error) {
      console.error('Error fetching data', error)
    }
  }
  // To get data
  useEffectOnce(() => {
    fetchDataAsync();
    fetchDataViewAsync();

  }, [dispatch]);


  const [acceptfield, setfield] = useState(false);
  const [docData, setDocData] = useState({
    docid: '',
  });
  const viewDoc = (response: any) => {
    setDocData({
      docid: response.DocID

    });
    setfield(true);
    fetchdocdata(response.DocID);
  };
  const cancelfield = () => {
    setfield(false);
  }
  //To assign data 

  const fetchdocdata = async (docid: any) => {
    // const { docid } = docData;
    try {
      await dispatch(fetchviewDoc(docid) as any);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  //for help
  const [openHelp, setHelp] = useState(false);
  const url1 = window.sessionStorage.getItem("apiRoot");
  const IUrl = `${url1}/help/adminvieworganizations.php`;
  const helpImg = `${url1}/help/help3.png`;
  const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
    event.preventDefault();
    const newWindowReference = window.open(
      targetUrl,
      'newwindow',
      'width=1000,height=1000,noopener,noreferrer'
    );

    if (newWindowReference) {
      newWindowReference.opener = null;
    }
  };


  return (
    <div className="admin-layout-container">
      <div className="row">
        <div className="main-content">
          {/* <div className="col-16" style={{ textAlign: "right" }}>
            <a
              title="help"
              onClick={(e) => openWindow(e, IUrl)}
              style={{

                color: "blue",
                fontSize: 15, cursor: "pointer"
              }}
            >Help for this Page &nbsp;
              <i style={{ marginTop: 40, backgroundColor: "orange", color: "white" }} className="pi pi-question-circle"></i>

            </a>
          </div> */}
           <section className="app-page-header">
              <div>
                <h1 className="app-page-title">View Organization</h1>
              </div>
              <a title="help" onClick={(e) => openWindow(e, IUrl)} className="app-help-link">
                Help for this Page
                <i className="pi pi-question-circle"></i>
              </a>
            </section>
          <div className="content-wrapper mt-4">
            {viewdata.map((response: any) =>
              <section className="content">
                <Card title="">
                  <Panel header="Organization Information">
                    <div className="grid">

                      <div className="col-12 md:col-12 lg:col-6">
                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ marginRight: '10px' }}>Organization Name :</strong>
                          <p className="text-muted">{response.nameoftheorg}</p>
                        </div>


                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ marginRight: '10px' }}>Organization Head :</strong>
                          <p className="text-muted">{response.nameofthehead}</p>
                        </div>

                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ marginRight: '10px' }}>Designation :</strong>
                          <p className="text-muted">{response.designation}</p>
                        </div>
                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ marginRight: '10px' }}>License No:</strong>
                          <p className="text-muted">{response.licenseno}</p>
                        </div>
                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ marginRight: '10px' }}>License Expired Date :</strong>
                          <p className="text-muted">{response.license_expdate}</p>
                        </div>
                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ marginRight: '10px' }}>Organization Type :</strong>
                          <p className="text-muted">{response.org_type}</p>
                        </div>

                      </div>
                      <div className="col-12 md:col-12 lg:col-6">
                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ marginRight: '10px' }}>Email :</strong>
                          <p className="text-muted">{response.email}</p>
                        </div>

                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ marginRight: '10px' }}>Address :</strong>
                          <p className="text-muted">{response.address}</p>
                        </div>
                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ marginRight: '10px' }}>Contact No :</strong>
                          <p className="text-muted">{response.mobile}</p>
                        </div>

                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ marginRight: '10px' }}>Country :</strong>
                          <p className="text-muted">{response.CountryName}</p>
                        </div>

                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ marginRight: '10px' }}>Paypal Account :</strong>
                          <p className="text-muted">{response.paypal_account}</p>
                        </div>
                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ marginRight: '10px' }}>Status :</strong>
                          <p className="text-muted">{response.status}</p>
                        </div>
                      </div>
                    </div>
                  </Panel>
                </Card>
              </section>
            )}
            <section className="content">
              <Card title="">
                <Panel header="Attachments">
                  <div className="grid">
                    <div className="col-12">
                      <div className="card card-primary">
                        <div className="card flex flex-wrap justify-content">
                          <span className="p-input-icon-left">
                            <i className="pi pi-search" />
                            <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" />
                          </span>
                        </div>
                        <DataTable value={data} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} >
                          <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                          <Column field="doc_name" sortable header="Attachment Name"></Column>
                          <Column field="CreteDate" sortable header="Expiry Date"></Column>
                          <Column header="View" body={(rowData,{rowIndex}) => (
                            <>
                              <GFNButton icon="pi pi-eye" testId={`view-btn-${rowIndex}`} buttonType="primary" size="sm" tooltip="View" onClick={() => viewDoc(rowData)} />
                            </>
                          )} />
                        </DataTable>

                      </div>
                    </div>
                  </div>
                </Panel>
              </Card>

            </section>
          </div>

          {/* docment view */}
          <Dialog header="View" style={{ width: '50vw' }} visible={acceptfield} onHide={cancelfield}>
            <div className="modal-header">

            </div>
            <form>
              <div className="modal-body">
                {docdata.map((rowData: any, index: number) =>
                  <div key={index}>
                    {rowData.filetype === 'image' && <img src={rowData.displayfile} alt="Doc" width="100%" height="auto" />}

                  </div>
                )}
              </div>
            </form>
          </Dialog>
        </div>
      </div>
    </div>
  )
}
export default AdminViewOrg
